module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Red.4b5cc65a.png";